// extracted by mini-css-extract-plugin
export default {"formWrapper":"AddPromoCode_formWrapper__oGqsE","linkText":"AddPromoCode_linkText__r6zT+"};